import Lenis from 'lenis';

// Initialize Lenis smooth scrolling
export const initSmoothScroll = () => {
  // Create a new Lenis instance with default configurations
  const lenis = new Lenis({
    lerp: 0.1, // Lower values create smoother scrolling but slower response
    wheelMultiplier: 1, // Adjust the speed of mouse wheel scrolling
    smoothTouch: false, // Disable smooth scrolling on touch devices by default
    touchMultiplier: 2, // Adjust the speed of touch scrolling
  });

  // Lenis scroll event listener
  lenis.on('scroll', (e: any) => {
    // You can use this event to trigger animations or other effects
    // console.log(e);
  });

  // RAF loop for Lenis
  function raf(time: number) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }

  // Start the animation loop
  requestAnimationFrame(raf);

  // Return the lenis instance in case it needs to be accessed elsewhere
  return lenis;
};

// Export a function to stop Lenis when needed
export const stopSmoothScroll = (lenis: any) => {
  if (lenis) {
    lenis.destroy();
  }
};
